import { INCREMENT_LAYER_COUNT } from 'api/actions'
import SelectLayer from 'drawer/tabs/layers/utils/SelectLayer'
import UnSelectLayer from 'drawer/tabs/layers/utils/UnSelectLayer'

export const SET_GROUP_COLLAPSED = 'SET_GROUP_COLLAPSED'
export const SET_GROUP_EXPANDED = 'SET_GROUP_EXPANDED'
export const ADD_LAYER = 'ADD_LAYER'
export const ADD_LAYERS = 'ADD_LAYERS'
export const ADD_GROUPS_FROM_LAYERS = 'ADD_GROUPS_FROM_LAYERS'
export const ADD_PROFILES_FROM_LAYERS = 'ADD_PROFILES_FROM_LAYERS'
export const SET_CURRENT_PROFILE = 'SET_CURRENT_PROFILE'
export const SET_LAYER_ID = 'SET_LAYER_ID'
export const SET_LAYER_IN_DRAWER_VISIBLE = 'SET_LAYER_IN_DRAWER_VISIBLE'
export const SET_LAYER_IN_DRAWER_HIDDEN = 'SET_LAYER_IN_DRAWER_HIDDEN'
export const SET_LAYER_VISIBLE = 'SET_LAYER_VISIBLE'
export const SET_LAYER_HIDDEN = 'SET_LAYER_HIDDEN'
export const SET_LAYER_SELECTED = 'SET_LAYER_SELECTED'
export const SET_LAYER_UNSELECTED = 'SET_LAYER_UNSELECTED'
export const SET_LAYER_PANELS_OPEN = 'SET_LAYER_PANEL_OPEN'
export const SET_LAYER_PANELS_CLOSED = 'SET_LAYER_PANEL_CLOSED'
export const SET_LAYER_PANELS_FEATURE_OPEN = 'SET_LAYER_PANELS_FEATURE_OPEN'
export const SET_LAYER_FILTER = 'SET_LAYER_FILTER'
export const SET_LAYER_REPORT = 'SET_LAYER_REPORT'
export const SET_LAYER_LOAD_NOT_STARTED = 'SET_LAYER_LOAD_NOT_STARTED'
export const SET_LAYER_LOAD_IN_PROGRESS = 'SET_LAYER_LOAD_IN_PROGRESS'
export const SET_LAYER_LOAD_DONE = 'SET_LAYER_LOAD_DONE'
export const SET_LAYER_LOAD_FAILED = 'SET_LAYER_LOAD_FAILED'
export const SET_LAYER_STYLE_GEOSTYLER = 'SET_LAYER_STYLE_GEOSTYLER'

export const setGroupExpanded = group => ({
  type: SET_GROUP_EXPANDED,
  group
})

export const setGroupCollapsed = group => ({
  type: SET_GROUP_COLLAPSED,
  group
})

export const addLayers = layers => {
  // Cater for situation where multiple layers get added in one go
  const count = ([].concat(layers)).length

  return dispatch => {
    dispatch({
      type: ADD_LAYERS,
      layers
    })

    dispatch({
      type: INCREMENT_LAYER_COUNT,
      count
    })

    dispatch({
      type: ADD_GROUPS_FROM_LAYERS,
      layers
    })

    dispatch({
      type: ADD_PROFILES_FROM_LAYERS,
      layers
    })
  }
}

// the function addLayer can handle one or more layers
export const addLayer = addLayers

export const setCurrentProfile = profileId => ({
  type: SET_CURRENT_PROFILE,
  profileId
})

export const setLayerVisible = titleid => ({
  type: SET_LAYER_VISIBLE,
  titleid
})

export const setLayerHidden = titleid => ({
  type: SET_LAYER_HIDDEN,
  titleid
})

export const setLayerId = (titleid, id) => ({
  type: SET_LAYER_ID,
  titleid,
  id
})

export const setLayerInDrawerVisible = titleid => ({
  type: SET_LAYER_IN_DRAWER_VISIBLE,
  titleid
})

export const setLayerInDrawerHidden = titleid => ({
  type: SET_LAYER_IN_DRAWER_HIDDEN,
  titleid
})

export const setLayerSelected = titleid => {
  return dispatch => {
    dispatch({
      type: SET_LAYER_SELECTED,
      titleid
    })
    SelectLayer(titleid)
  }
}

export const setLayerUnselected = titleid => {
  return dispatch => {
    dispatch({
      type: SET_LAYER_UNSELECTED,
      titleid
    })
    UnSelectLayer(titleid)
  }
}

export const setLayerPanelsOpen = titleid => ({
  type: SET_LAYER_PANELS_OPEN,
  titleid
})

export const setLayerPanelsClosed = titleid => ({
  type: SET_LAYER_PANELS_CLOSED,
  titleid
})

export const setLayerPanelsFeatureOpen = (titleid, panelFeatureTitle) => ({
  type: SET_LAYER_PANELS_FEATURE_OPEN,
  titleid,
  panelFeatureTitle
})

export const setLayerFilter = (titleid, propsFilter) => ({
  type: SET_LAYER_FILTER,
  titleid,
  propsFilter
})

export const setLayerReport = (titleid, reportGroup) => ({
  type: SET_LAYER_REPORT,
  titleid,
  reportGroup
})

export const setLayerLoadNotStarted = titleid => ({
  type: SET_LAYER_LOAD_NOT_STARTED,
  titleid
})

export const setLayerLoadInProgress = titleid => ({
  type: SET_LAYER_LOAD_IN_PROGRESS,
  titleid
})

export const setLayerLoadDone = titleid => ({
  type: SET_LAYER_LOAD_DONE,
  titleid
})

export const setLayerLoadFailed = titleid => ({
  type: SET_LAYER_LOAD_FAILED,
  titleid
})

export const setLayerStyleGeoStyler = (titleid, style) => ({
  type: SET_LAYER_STYLE_GEOSTYLER,
  style,
  titleid
})
